import React from 'react';
import { FlexRow } from '../../../../common/components/v2';
import { Resource } from '../../../../common/constants/resource';
import styles from '../../styles.module.scss';

export const RenderMVRMiscellaneousSection = (miscellaneous: string) => {
  return (
    <>
      <FlexRow className={styles.TaskSubtitle}>
        {Resource.MVR_LICENSE_MISCELLANEOUS}
      </FlexRow>
      <p className={styles.Verbose}>{miscellaneous}</p>
    </>
  );
};
